<template lang="pug">
    el-dialog(:visible.sync="mutableEditDialogVisible", fullscreen=false, title="", :close-on-click-modal="false", append-to-body, width="80%")
      .container(id="HolidaysetEdit-container")
        .row
          el-form(
            :model="holidaySetData",
            ref="dateTimeSetForm",
            size="mini",
            :inline="true"
          )
            el-form-item(:label="holidaySetData.id ? $t('Edit Play Period Set') : $t('Add Play Period Set')", prop="name")
              el-input(id="HolidaysetEdit-nameInput" v-model="holidaySetData.name", style="width:400px;")
                el-button.float-right(
                  type="success",
                  id="HolidaysetEdit-saveButton"
                  size="small"
                  slot="append"
                  @click="submitForm('dateTimeSetForm')"
                  :disabled="loading"
                )
                  font-awesome-icon.icon(icon="save")
        .row(v-for='holidayPeriod of holidayPeriodsSorted' :id="'HolidaysetEdit-period' + holidayPeriod.id")
          el-date-picker(:picker-options="{ firstDayOfWeek: 1 }", v-model="holidayPeriod.firstPlayDate", @input='holidayPeriodChanged(holidayPeriod)', type="datetime", format='yyyy-MM-dd HH:mm', :placeholder="$t('start date and time')", :clearable='false')
          el-date-picker(:picker-options="{ firstDayOfWeek: 1 }", v-model="holidayPeriod.lastPlayDate", @input='holidayPeriodChanged(holidayPeriod)', type="datetime", format='yyyy-MM-dd HH:mm', :placeholder="$t('end date and time')", :clearable='false')
          el-button(size="mini", type="text", @click='deleteHolidayPeriod(holidayPeriod)')
            font-awesome-icon.icon(icon="minus")
          el-button(size="mini", type="text", @click='updateHolidayPeriod(holidayPeriod)', v-if='holidayPeriodIsValid(holidayPeriod) && holidayPeriod.changed')
            font-awesome-icon.icon(icon="save")
        .row(v-if='holidaySetData.id', id="HolidaysetEdit-newPeriod")
          el-date-picker(:picker-options="{ firstDayOfWeek: 1 }", v-model="newHolidayPeriod.firstPlayDate", type="datetime", format='yyyy-MM-dd HH:mm', :placeholder="$t('start date and time')")
          el-date-picker(:picker-options="{ firstDayOfWeek: 1 }", v-model="newHolidayPeriod.lastPlayDate", type="datetime", format='yyyy-MM-dd HH:mm', :placeholder="$t('end date and time')")
          el-button(size="mini", type="text", @click='addnewHolidayPeriod()', :disabled='!holidayPeriodIsValid(newHolidayPeriod)')
            font-awesome-icon.icon(icon="plus")
</template>

<script>

export default {
  props: {
    'holidaySetId': {
      required: true
    },
    'editDialogVisible': {
      required: true
    }
  },
  data () {
    return {
      loading: false,
      newHolidayPeriod: {
        firstPlayDate: null,
        lastPlayDate: null
      },
      holidaySetData: {
        id: 0,
        name: ''
      },
      holidayPeriodsSorted: []
    }
  },
  created () {
  },
  watch: {
    holidaySetId: async function (newVal, oldVal) {
      this.resetData()
      if (newVal === oldVal) return
      this.loading = true
      this.$nextTick(function () {
        this.$refs['dateTimeSetForm'].resetFields()
      })
      if (this.holidaySetId > 0) {
        await this.loadHolidaySetData()
      }
      this.loading = false
    }
  },
  methods: {
    resetData () {
      this.holidayPeriodsSorted = []
      this.holidaySetData = {
        id: 0,
        name: ''
      }
    },
    holidayPeriodIsValid (holidayPeriod) {
      // if (!holidayPeriod.firstPlayDate || !holidayPeriod.lastPlayDate) return false
      if (!holidayPeriod.lastPlayDate) return false
      if (this.$moment(holidayPeriod.firstPlayDate).isSameOrAfter(this.$moment(holidayPeriod.lastPlayDate))) return false
      return true
    },
    holidayPeriodChanged (holidayPeriod) {
      holidayPeriod.changed = true
    },
    async loadHolidaySetData () {
      this.holidaySetData = await this.$store.dispatch('Holidayset/getHolidaySetData', {
        data: {
          holidaysetId: this.holidaySetData.id ? this.holidaySetData.id : this.holidaySetId
        }
      })
      this.holidayPeriodsSorted = JSON.parse(JSON.stringify(this.holidaySetData.HolidayPeriods)).sort((a, b) => a.firstPlayDate.localeCompare(b.firstPlayDate))
    },
    async submitForm (formName) {
      this.loading = true
      const result = await this.$store.dispatch(this.holidaySetId === 0 ? 'Holidayset/createHolidaySetData' : 'Holidayset/updateHolidaySetData', {
        data: {
          id: this.holidaySetData.id,
          name: this.holidaySetData.name
        }
      })
      this.loading = false
      this.holidaySetData.id = result.id
    },
    async addnewHolidayPeriod () {
      await this.$store.dispatch('Holidayset/createHolidayPeriod', {
        newHolidayPeriod: this.newHolidayPeriod,
        holidaySetId: this.holidaySetData.id
      })
      this.newHolidayPeriod = {
        firstPlayDate: null,
        lastPlayDate: null
      }
      await this.loadHolidaySetData()
    },
    async updateHolidayPeriod (holidayPeriod) {
      await this.$store.dispatch('Holidayset/updateHolidayPeriod', holidayPeriod)
      await this.loadHolidaySetData()
    },
    async deleteHolidayPeriod (holidayPeriod) {
      await this.$store.dispatch('Holidayset/deleteHolidayPeriod', holidayPeriod)
      await this.loadHolidaySetData()
    }
  },
  computed: {
    mutableEditDialogVisible: {
      get: function () {
        return this.editDialogVisible
      },
      set: function (value) {
        this.$emit('closeEditDialog', value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container {
  .row {
    text-align: left;
    margin-left: 30%;
  }
  .icon {
    margin-left: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Holidayset/HolidaysetEdit.vue